import { useCallback } from 'react';

import Status from 'components/field/Status';
import Tag from 'components/global/Tag';
import Tooltip from 'components/global/Tooltip';

import * as S from './ChipViewer.styled';

const WarehouseWorkingStatus = ({ data }) => {
	const hours = data?.operationalHours && Array.isArray(data?.operationalHours) ? data?.operationalHours : [];
	const tooltipContent = useCallback(() => (
		<S.Container>
			{hours.map((shift) => (
				<Tag variant="disabled" key={shift.start} label={`${shift.start}-${shift.end}`} />
			))}
		</S.Container>
	));
	if (hours.length === 0) {
		return <Status value="pickupLocationClosed" />;
	}
	return (
		<Tooltip title={tooltipContent()} showOnMobile={false}>
			<div>
				<Status value={data?.pickupLocationStatus} />
			</div>
		</Tooltip>
	);
};

export default WarehouseWorkingStatus;
